/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import useSWRInfinite from "swr/infinite";
import { useInView } from "react-intersection-observer";
import { isAndroid, isIOS, browserName } from "react-device-detect";
import { mutate } from "swr";

import {
  getSettingState,
  setLoadNavigation,
} from "../../../redux/features/settingSlice";
import TableCarts from "../TableList/TableCarts/index";
import { getPlayerState } from "../../../redux/features/playerSlice";
import TableLoadingCart from "../TableList/TableLoadingCart/index";
import UseWindowDimensions from "../../../utils/windowSize";
import CategoryHeader from "./CategoryHeader";
import CustomHelmet from "../CustomHelmet";
import { fetcherGetToken } from "../../../services/fetcher";
import logoType from "../../../media/svg/logo-type.svg";
import logoIcon from "../../../media/svg/logo-icon.svg";
import AppAlertBox from "../AppAlertBox";
import { DetectPwa } from "./../../../utils/DetectPwa";
import NewTableCards from "../TableList/NewTableCards";

const MainTableList = () => {
  const { minimizePlayer } = useSelector(getPlayerState);
  const { categoryIdMain } = useSelector(getSettingState);
  const dispatch = useDispatch();
  const { height } = UseWindowDimensions();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;
  const { userData, appAlert } = useSelector(getSettingState);
  // alert(isChromium);
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const {
    data: mainTable,
    isLoading,
    size,
    setSize,
  } = useSWRInfinite(
    (pageIndex, previousPageData) => {
      if (previousPageData && !previousPageData.results.length) return null;
      return [
        `${process.env.REACT_APP_API}/content/${
          categoryIdMain ? `profile/${categoryIdMain}/${userData}` : `v2/tables`
        }/?page=${pageIndex + 1}`,
        tokenStorage,
      ];
    },
    fetcherGetToken,
    {
      revalidateFirstPage: true,
      refreshInterval: 7000,
      // initialSize: 1,
    }
  );

  useEffect(() => {
    mainTable &&
      mutate([
        `${process.env.REACT_APP_API}/notifications/unread-count/`,
        tokenStorage,
      ]);
  }, [mainTable, tokenStorage]);

  useEffect(() => {
    dispatch(setLoadNavigation(isLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, inView]);

  useEffect(() => {
    inView && moreInfinite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const moreInfinite = () => {
    const moreParticipantCart =
      mainTable && size + 1 <= mainTable[0]?.total_pages;
    if (moreParticipantCart) {
      setSize(size + 1);
      dispatch(setLoadNavigation(true));
    } else {
      // setSize(mainTable[0]?.total_pages);
    }
  };

  const tableList = () => {
    let mTableList = [];
    if (mainTable) {
      // eslint-disable-next-line array-callback-return
      mainTable.map((e) => {
        mTableList.push(...e.results);
      });
    }
    return mTableList;
  };

  return (
    <>
      <CustomHelmet
        title='Tables | Azad'
        description={"Environment for discussion and exchange of opinions.."}
        imgUrl={logoIcon}
      />
      <Box
        sx={{
          padding: "0px 16px 0 16px",
          backgroundColor: "white.main",
          height: height - 61 - (minimizePlayer ? 82 : 0) + "px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {/* {isIOS &&
          appAlert &&
          DetectPwa() !== "pwa" &&
          browserName !== "Chrome WebView" && <AppAlertBox />} */}
        <Box
          sx={{
            padding: "16px 0 10px 0",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <img src={logoType} alt='Azad Logo Name' width='auto' height='26px' />
          <img src={logoIcon} alt='Azad Logo Icon' width='auto' height='32px' />
        </Box>

        {userData && <CategoryHeader />}
        <Box>
          {!mainTable &&
            Array(3)
              .fill("")
              .map((row, i) => {
                return <TableLoadingCart key={i} />;
              })}

          {mainTable &&
            tableList().map((row) => {
              return <NewTableCards key={row.pk} rowData={row} />;
            })}

          {!isLoading && mainTable && (
            <Box
              ref={ref}
              sx={{ display: "flex", justifyContent: "center", pb: "2px" }}
            ></Box>
          )}
        </Box>
      </Box>
    </>
  );
};
export default MainTableList;
